import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-bottom-label',
  templateUrl: './handover-bottom-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverBottomLabelComponent implements OnInit {

  @Input() model?: HandoverModel;

  constructor() { }

  ngOnInit(): void {
  }

}
